import React from 'react';

const PageError = () => (
    <div className="md-col-6 mx-auto center px2">
        <div className="mt4">
            <h2>We couldn't find that page.</h2>
            <img className="" src="/img/fish-skeleton.png" height="200" alt="Not found fish" />
            <p>This page has either been deleted, archived or you do not have access to it.</p>
        </div>
    </div>
);

export default PageError;
